import type { BaseActionStore } from './types';
import reducer from './reducer';

const baseStore = {
  reducer,
};

export type { BaseActionStore };
export default baseStore;
